import { Component } from '@angular/core';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { ReportFinalComponent } from '../report-final/report-final.component';
import { ReportAOComponent } from '../report-ao/report-ao.component';

import { PageHeaderComponent } from 'src/app/shared/ui/page-header/page-header.component';

@Component({
    selector: 'app-reporting-tabs',
    templateUrl: './reporting-tabs.component.html',
    styleUrls: ['./reporting-tabs.component.scss'],
    imports: [MatTabGroup, MatTab, ReportFinalComponent, ReportAOComponent, PageHeaderComponent]
})
export class ReportingTabsComponent {}
